import { render, staticRenderFns } from "./DocumentChooserFilters.vue?vue&type=template&id=71a878c5&"
import script from "./DocumentChooserFilters.vue?vue&type=script&lang=ts&"
export * from "./DocumentChooserFilters.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentChooserFilters.vue?vue&type=style&index=0&id=71a878c5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports